import React from "react";
import Dnav from "../components/Dnav";
import Dotable from "../components/Dotable";
import Homefooter from "../components/Homefooter";

function Dorders() {
    return (
        <>
            <Dnav />
            <Dotable />
            <Homefooter />
        </>
    );
}

export default Dorders;